import React, { useEffect } from "react";
import UsersManagement from "../../../components/utilizadores/gestaoUtilizadores";
import AppbarDrawer from "../../../components/drawer/drawer";

const GestaoUtilizadoresPag = () => {
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <AppbarDrawer>
      <UsersManagement />
    </AppbarDrawer>
  );
};
export default GestaoUtilizadoresPag;
